import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../../store';
import { getDashboardResumen } from '../../services';
import CountUp from 'react-countup';
import { JobCategories } from '../../markup/Element/JobCategories';
import { Jobsection } from '../../markup/Element/Jobsection';
import { Owltestimonial } from '../../markup/Element/Owlblog1';
import { IndexBanner } from '../../markup/Element/IndexBanner';
import { LogoSpinner } from '../../components/LogoSpinner';
import { useLanguage } from '../../i18n/LanguageContext';

//Images
var bnr2 = require('./../../images/background/bg4.jpg');
var bnr3 = require('./../../images/lines.png');

export function Homepage() {
	const { isAuthReady } = useAuthStore();
	const { t } = useLanguage();
	const [dashboard, setDashboard] = useState({ totalEmpresas: 0, totalUsuarios: 0, totalVacantes: 0 });
	const [loadingDashboard, setLoadingDashboard] = useState(true);

	useEffect(() => {
		getDashboardResumen()
			.then(res => {
				setDashboard(res.data);
			})
			.catch(() => {
				setDashboard({ totalEmpresas: 0, totalUsuarios: 0, totalVacantes: 0 });
			})
			.finally(() => setLoadingDashboard(false));
	}, []);

	if (!isAuthReady) {
		return <LogoSpinner />;
	}

	return (
		<div className="page-content">
			<IndexBanner />
			{/* Call to Action */}
			<div
				className="section-full content-inner-2 overlay-white-middle"
				style={{
					backgroundImage: "url(" + bnr3 + ")",
					backgroundPosition: "center center",
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover"
				}}
			>
				<div className="container">
					<div className="section-head text-black text-center m-b50">
						<h2 className="m-b10" style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>
							{t('home.connectNow')}
						</h2>
						<div className="dez-separator-outer">
							<div className="dez-separator bg-primary"></div>
						</div>
						<p className="m-t30 font-18" style={{ maxWidth: '700px', margin: '30px auto 0' }}>
							{t('home.connectSubtitle')}
						</p>
					</div>
					<div className="row m-t50">
						<div className="col-lg-6 col-md-6 col-sm-12 m-b30">
							<div className="icon-bx-wraper p-a40 center bg-white radius-sm h-100" style={{ boxShadow: '0 5px 20px rgba(0,0,0,0.1)' }}>
								<div className="icon-xl text-primary m-b20" style={{ fontSize: '60px' }}>
									<i className="ti-search"></i>
								</div>
								<h3 className="m-b15">{t('home.lookingForJob')}</h3>
								<p className="m-b30">{t('home.lookingForJobDesc')}</p>
								<Link to={"/browse-job-filter-grid"} className="site-button radius-xl">
									<span>{t('home.searchJobs')} <i className="ti-arrow-right m-l5"></i></span>
								</Link>
							</div>
						</div>
						<div className="col-lg-6 col-md-6 col-sm-12 m-b30">
							<div className="icon-bx-wraper p-a40 center bg-primary text-white radius-sm h-100" style={{ boxShadow: '0 5px 20px rgba(0,0,0,0.1)' }}>
								<div className="icon-xl m-b20" style={{ fontSize: '60px' }}>
									<i className="ti-briefcase"></i>
								</div>
								<h3 className="m-b15">{t('home.areYouCompany')}</h3>
								<p className="m-b30">{t('home.areYouCompanyDesc')}</p>
								<Link to={"/register"} className="site-button white radius-xl">
									<span className="text-primary">{t('home.postVacancy')} <i className="ti-arrow-right m-l5"></i></span>
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>


			{/* Sección Hero: El Vínculo */}
			<div className="section-full content-inner overlay-white-middle bg-gray" style={{ paddingTop: '80px', paddingBottom: '80px' }}>
				<div className="container">
					<div className="section-head text-center m-b50">
						<h2 className="m-b10" style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>
							{t('home.findTheRightSolution')}
						</h2>
						<div className="dez-separator-outer">
							<div className="dez-separator bg-primary"></div>
						</div>
						<p className="m-t30 font-18" style={{ maxWidth: '800px', margin: '30px auto 0' }}>
							{t('home.heroSubtitle')}
						</p>
					</div>
					<div className="row m-t50">
						{/* Empresas (izquierda) */}
						<div className="col-lg-4 col-md-4 col-sm-12 m-b30">
							<div className="icon-bx-wraper p-a40 center bg-white radius-sm h-100" style={{ boxShadow: '0 5px 20px rgba(0,0,0,0.1)', transition: 'all 0.3s' }}>
								<div className="icon-xl text-primary m-b20" style={{ fontSize: '60px' }}>
									<i className="ti-briefcase"></i>
								</div>
								<h3 className="m-b15">{t('home.companies')}</h3>
								<div aria-label={t('home.companiesCountLabel')} style={{ fontSize: '2rem', fontWeight: '700', color: '#009247' }}>
									{loadingDashboard ? '...' : <CountUp end={dashboard.totalEmpresas} duration={2} />}
								</div>
								<div style={{ fontSize: '0.9rem', color: '#666' }}>{t('home.companiesAllied')}</div>
							</div>
						</div>
						{/* Usuarios normales (centro) */}
						<div className="col-lg-4 col-md-4 col-sm-12 m-b30">
							<div className="icon-bx-wraper p-a40 center bg-primary text-white radius-sm h-100" style={{ boxShadow: '0 5px 20px rgba(0,0,0,0.1)', transition: 'all 0.3s' }}>
								<div className="icon-xl m-b20" style={{ fontSize: '60px' }}>
									<i className="ti-user"></i>
								</div>
								<h3 className="m-b15">{t('home.users')}</h3>
								<div style={{ fontSize: '2rem', fontWeight: '800', marginBottom: 8 }}>
									{/* {loadingDashboard ? '...' : <CountUp end={dashboard.totalUsuarios} duration={2} />} */}
									{loadingDashboard ? '...' : <CountUp end={1000 + dashboard.totalUsuarios} duration={2} />}
								</div>
								<div style={{ fontSize: '0.9rem' }}>{t('home.students')} + {t('home.graduates')}</div>
							</div>
						</div>
						{/* Vacantes (derecha) */}
						<div className="col-lg-4 col-md-4 col-sm-12 m-b30">
							<div className="icon-bx-wraper p-a40 center bg-white radius-sm h-100" style={{ boxShadow: '0 5px 20px rgba(0,0,0,0.1)', transition: 'all 0.3s' }}>
								<div className="icon-xl text-primary m-b20" style={{ fontSize: '60px' }}>
									<i className="ti-book"></i>
								</div>
								<h3 className="m-b15">Vacantes</h3>
								<div aria-label="Cantidad de vacantes" style={{ fontSize: '2rem', fontWeight: '700', color: '#009247' }}>
									{loadingDashboard ? '...' : <CountUp end={dashboard.totalVacantes} duration={2} />}
								</div>
								<div style={{ fontSize: '0.9rem', color: '#666' }}>Vacantes publicadas</div>
							</div>
						</div>
					</div>
				</div>
			</div>


			<Jobsection />
		</div>
	)
}